import { Injectable } from "@angular/core";
import { AuthenticationService } from "../authentication.service";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
// import { IApprovalRuleMaster, ApprovalRule_Master } from '../../interface/ApprovalRule_Master';
// import { IApprovalDetailsMaster, ApprovalDetails_Master } from '../../interface/ApprovalDetails_Master';

@Injectable()
export class ApprovalService {

  // ApprovalRules: ApprovalRule_Master[] = [];
  // ApprovedDetailList: ApprovalDetails_Master[] = [];
  // ApprovedDetail: IApprovalDetailsMaster;

  constructor(private auth: AuthenticationService, private http: Http) {
    // this.ApprovedDetail = new ApprovalDetails_Master();
   }

  Get_ApprovalRulesByType(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ApprovalRulesByType",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  // Save_ApprovalDetail(model: any) {
  //   return this.http
  //     .post(
  //       this.auth.baseUrl + "/services/api/v1/Save_ApprovalDetail",
  //       model,
  //       this.auth.getHeader()
  //     )
  //     .map(res => {
  //       return res.json();
  //     });
  // }

  // Delete_ApprovalDetail(model: any){
  //   return this.http
  //   .post(
  //     this.auth.baseUrl + "/services/api/v1/Delete_ApprovalDetail",
  //     model,
  //     this.auth.getHeader()
  //   )
  //   .map(res => {
  //     return res.json();
  //   });
  // }

  ApprovalRulesCheck(model: any,LocId:number,Type:number):Observable<any>{
    var data={
      Id:Type,
      LocationId:LocId
    }
      return this.Get_ApprovalRulesByType(data)
      .map(((x:any)=>{
        if(x.Success){
          x.data.forEach(r => {
            r.Result = this.evalRule(r.Rules,model);
          });
        }      
        return x;
      })
      )
  }

  evalRule(rule: string,model) {
    var res = false;
    try {
      var fn = new Function('s', 'return ' + rule);
      res = fn(model);
    } catch (e) {
    }
    return res;
  }

  // ValidateApprovalRules(TypeId:number,LocId:number,InvNo:number,VoucherNo:string,Amount:number,model:any,isedit:boolean){
  //   this.ApprovalRulesCheck(model,LocId,TypeId).subscribe(res=>{
  //     if (res.Success) {
  //       this.ApprovalRules = res.data;
  //       this.ApprovedDetailList = [];
  //       for (let i of this.ApprovalRules) {
  //         if (i.Result == true) {
  //           this.ApprovedDetail.Id = 0;
  //           this.ApprovedDetail.InvNo = InvNo;
  //           this.ApprovedDetail.IsApproved = false;
  //           this.ApprovedDetail.LocId = LocId;
  //           this.ApprovedDetail.Message = i.Description;
  //           this.ApprovedDetail.RuleId = i.Id;
  //           this.ApprovedDetail.RuleName = i.RuleName;
  //           this.ApprovedDetail.Type = i.Type;
  //           this.ApprovedDetail.ApprovedBy = 0;
  //           this.ApprovedDetail.VoucherNo = VoucherNo;
  //           this.ApprovedDetail.Amount = Amount;
  //           this.ApprovedDetail.TypeId = i.TypeId
  //           this.ApprovedDetailList.push(this.ApprovedDetail);
  //           this.ApprovedDetail = new ApprovalDetails_Master();
  //         }
  //       }
  //       if (this.ApprovedDetailList.length != 0) {
  //         this.Save_ApprovalDetail(this.ApprovedDetailList).subscribe(res => {
  //           if (res.Success) {
  //             if(TypeId==31){
  //               var update: any = {
  //                 ID: InvNo,
  //                 LocationId: LocId,
  //                 status: -1
  //               }
  //               // this.ps.updateLPOStatus(update).subscribe(up => {
  //               //   if (up.Success) {
  //               //     // console.log(res)
  //               //   }
  //               // })
  //             }
             
  //           }
  //           else {
  //             alert(res.error.UsrMsg);
  //           }
  //         })
  //       }
  //       else if (isedit && this.ApprovedDetailList.length == 0) {
  //         var data = {
  //           TypeId: TypeId,
  //           LocId: LocId,
  //           InvNo: InvNo
  //         }
  //         this.Delete_ApprovalDetail(data).subscribe(up => {
  //           if (up.Success) {
  //           }
  //         })
  //       }
  //     }
  //     else{

  //     }
  //   })

  // }

  Check_ApprovalDetails(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Check_ApprovalDetails",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  
  Update_TransactionApprovalStatus(model: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_TransactionApprovalStatus",
        model,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

}





// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/tools/approval.service.ts